exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".game-game_over_screen {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    background-color: hsla(0, 0%, 15%, 0.4);\n}\n\n.game-game_over_screen-button {\n    background-color: hsla(0, 0%, 15%, 0.4);\n    border: 1px solid black;\n    font-size: 1em;\n\n    padding: 0.5em 2em;\n    margin: 1.5em;\n}\n\n.game-blurred {\n    -webkit-filter: blur(2px);\n    filter: blur(2px);\n}\n\n[name=\"instructions\"] p {\n    display: inline-block;\n    max-width: 600px;\n    text-align: center;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/game.css
 ** module id = 106
 ** module chunks = 0
 **/